var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Clipper, Components, Cullers, FragmentsManager, Grids, IfcLoader, IfcRelationsIndexer, OrthoPerspectiveCamera, Raycasters, SimpleRenderer, SimpleScene, Worlds, } from '@thatopen/components';
import { ClipEdges, EdgesPlane, Highlighter } from '@thatopen/components-front';
import { Manager } from '@thatopen/ui';
import { tables } from '@thatopen/ui-obc';
import Stats from 'stats.js';
import { InstancedMesh, LineBasicMaterial, Mesh, MeshBasicMaterial, } from 'three';
var IFCViewer = /** @class */ (function () {
    function IFCViewer(conatiners, options) {
        //Core
        this._currentWorld = null;
        this._components = null;
        this._statsPanel = null;
        this._currentGrid = null;
        this._currentCuller = null;
        this._currentFragmentIfcLoader = null;
        this._currentFragmentsManager = null;
        this._cullers = null;
        this._currentIfcRelationsIndexer = null;
        this._currentRelationsTree = null;
        //Custers
        this._currentRayCaster = null;
        this._currentClipper = null;
        this._edges = null;
        //DOM
        this._sceneContainerRef = null;
        this._controlPanelContainerRef = null;
        this._modalInfroPanelContainerRef = null;
        //Handlers
        this._onKeyDownHandlerRef = null;
        this._onDoubleClickHandlerRef = null;
        this._onBeforeUpdateHandlerRef = null;
        this._onAfterUpdateHandlerRef = null;
        this._projectionOnChangedRef = null;
        this._cameraControlendHandlerRef = null;
        this._loadIfcFileHandlerRef = null;
        this._disposeFragmentsHandlerRef = null;
        this._onResizeHandlerRef = null;
        this._onFragmentsLoadedHandlerRef = null;
        //state
        this._state = {
            stub: false,
        };
        this.setContainers(conatiners);
        this.initialize(options);
    }
    Object.defineProperty(IFCViewer.prototype, "currentWorld", {
        get: function () {
            return this._currentWorld;
        },
        enumerable: false,
        configurable: true
    });
    IFCViewer.prototype.destroy = function () {
        var _a, _b, _c, _d, _e;
        if ((_a = this._sceneContainerRef) === null || _a === void 0 ? void 0 : _a.current) {
            if (this._onKeyDownHandlerRef) {
                this._sceneContainerRef.current.removeEventListener('keydown', this._onKeyDownHandlerRef);
            }
            if (this._onDoubleClickHandlerRef) {
                this._sceneContainerRef.current.removeEventListener('dblclick', this._onDoubleClickHandlerRef);
            }
        }
        if (((_c = (_b = this._currentWorld) === null || _b === void 0 ? void 0 : _b.camera) === null || _c === void 0 ? void 0 : _c.controls) && this._cameraControlendHandlerRef) {
            this._currentWorld.camera.controls.removeEventListener('controlend', this._cameraControlendHandlerRef);
        }
        if ((_d = this._currentWorld) === null || _d === void 0 ? void 0 : _d.renderer) {
            if (this._onBeforeUpdateHandlerRef) {
                this._currentWorld.renderer.onBeforeUpdate.remove(this._onBeforeUpdateHandlerRef);
            }
            if (this._onAfterUpdateHandlerRef) {
                this._currentWorld.renderer.onAfterUpdate.remove(this._onAfterUpdateHandlerRef);
            }
        }
        if (this._statsPanel) {
            if (this._statsPanel.dom.parentNode) {
                this._statsPanel.dom.parentNode.removeChild(this._statsPanel.dom);
            }
            this._statsPanel = null;
        }
        if ((_e = this._controlPanelContainerRef) === null || _e === void 0 ? void 0 : _e.current) {
            while (this._controlPanelContainerRef.current.firstChild) {
                this._controlPanelContainerRef.current.removeChild(this._controlPanelContainerRef.current.firstChild);
            }
        }
        if (this._components) {
            this._components.dispose();
            this._components = null;
        }
        this._currentWorld = null;
        this._currentGrid = null;
        this._currentCuller = null;
        this._currentFragmentIfcLoader = null;
        this._currentFragmentsManager = null;
        this._cullers = null;
        this._currentRayCaster = null;
        this._currentClipper = null;
        this._onKeyDownHandlerRef = null;
        this._onDoubleClickHandlerRef = null;
        this._onBeforeUpdateHandlerRef = null;
        this._onAfterUpdateHandlerRef = null;
        this._projectionOnChangedRef = null;
        this._cameraControlendHandlerRef = null;
        this._loadIfcFileHandlerRef = null;
        this._disposeFragmentsHandlerRef = null;
    };
    IFCViewer.prototype.setContainers = function (conatiners) {
        this._sceneContainerRef = conatiners.sceneContainer;
        this._controlPanelContainerRef = conatiners.controlPanelContainer;
        this._modalInfroPanelContainerRef = conatiners.modalInfroPanelContainer;
    };
    IFCViewer.prototype.initialize = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.setupWorld()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.setupIfcLoader()];
                    case 2:
                        _a.sent();
                        this.setupCasters();
                        this.setupStatsPanel();
                        this.setupUI(options.ui);
                        this.setupSceneContainerHandlers();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IFCViewer.prototype.setupSceneContainerHandlers = function () {
        var _a, _b, _c;
        this._onDoubleClickHandlerRef = this.onDoubleClickHandler.bind(this);
        (_a = this._sceneContainerRef) === null || _a === void 0 ? void 0 : _a.current.addEventListener('dblclick', this._onDoubleClickHandlerRef);
        this._onKeyDownHandlerRef = this.onKeyDownHandler.bind(this);
        (_b = this._sceneContainerRef) === null || _b === void 0 ? void 0 : _b.current.addEventListener('keydown', this._onKeyDownHandlerRef);
        this._onResizeHandlerRef = this.onResizeHandler.bind(this);
        (_c = this._sceneContainerRef) === null || _c === void 0 ? void 0 : _c.current.addEventListener('resize', this._onResizeHandlerRef);
    };
    IFCViewer.prototype.setupWorld = function () {
        return __awaiter(this, void 0, void 0, function () {
            var worlds, grids;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //World
                        this._components = new Components();
                        worlds = this._components.get(Worlds);
                        this._currentWorld = worlds.create();
                        this._currentWorld.scene = new SimpleScene(this._components);
                        this._currentWorld.scene.three.background = null;
                        this._currentWorld.renderer = new SimpleRenderer(this._components, this._sceneContainerRef.current);
                        this._currentWorld.camera = new OrthoPerspectiveCamera(this._components);
                        this._projectionOnChangedRef = this.projectionOnChanged.bind(this);
                        this._currentWorld.camera.projection.onChanged.add(this._projectionOnChangedRef);
                        this._components.init();
                        this._currentWorld.scene.setup();
                        grids = this._components.get(Grids);
                        this._currentGrid = grids.create(this._currentWorld);
                        //End
                        return [4 /*yield*/, this._currentWorld.camera.controls.setLookAt(10, 10, 10, 0, 0, 0)];
                    case 1:
                        //End
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IFCViewer.prototype.setupIfcLoader = function () {
        return __awaiter(this, void 0, void 0, function () {
            var highlighter, relationsTree;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._currentFragmentsManager = this._components.get(FragmentsManager);
                        this._currentFragmentIfcLoader = this._components.get(IfcLoader);
                        return [4 /*yield*/, this._currentFragmentIfcLoader.setup()];
                    case 1:
                        _a.sent();
                        this._currentFragmentIfcLoader.settings.webIfc.COORDINATE_TO_ORIGIN = true;
                        highlighter = this._components.get(Highlighter);
                        highlighter.setup({ world: this._currentWorld });
                        highlighter.zoomToSelection = true;
                        this._currentIfcRelationsIndexer = this._components.get(IfcRelationsIndexer);
                        this._onFragmentsLoadedHandlerRef = this.onFragmentsLoadedHandler.bind(this);
                        this._currentFragmentsManager.onFragmentsLoaded.add(this._onFragmentsLoadedHandlerRef);
                        relationsTree = tables.relationsTree({
                            components: this._components,
                            models: [],
                        })[0];
                        relationsTree.preserveStructureOnFilter = true;
                        this._currentRelationsTree = relationsTree;
                        return [2 /*return*/];
                }
            });
        });
    };
    IFCViewer.prototype.setupCuller = function (model) {
        var _this = this;
        if (this._currentCuller) {
            this._currentCuller.dispose();
        }
        if (!this._cullers) {
            this._cullers = this._components.get(Cullers);
        }
        this._currentCuller = this._cullers.create(this._currentWorld);
        this._currentCuller.needsUpdate = true;
        if (!this._cameraControlendHandlerRef) {
            this._cameraControlendHandlerRef = this.cameraControlendHandler.bind(this);
        }
        this._currentWorld.camera.controls.addEventListener('controlend', this._cameraControlendHandlerRef);
        if (!!model) {
            model.traverse(function (child) {
                if (child instanceof Mesh || child instanceof InstancedMesh) {
                    _this._currentCuller.add(child);
                }
            });
        }
        this._currentCuller.needsUpdate = true;
    };
    //Use features
    IFCViewer.prototype.setupCasters = function () {
        var casters = this._components.get(Raycasters);
        this._currentRayCaster = casters.get(this._currentWorld);
        this._currentClipper = this._components.get(Clipper);
        this._currentClipper.enabled = true;
        this._edges = this._components.get(ClipEdges);
        this._currentClipper.Type = EdgesPlane;
    };
    IFCViewer.prototype.setupClipperStyles = function (model) {
        var allMeshes = new Set();
        model.traverse(function (child) {
            if (child instanceof Mesh || child instanceof InstancedMesh) {
                allMeshes.add(child);
            }
        });
        var salmonFill = new MeshBasicMaterial({ color: 'salmon', side: 2 });
        var redLine = new LineBasicMaterial({ color: 'red' });
        var redOutline = new MeshBasicMaterial({
            color: 'red',
            opacity: 0.5,
            side: 2,
            transparent: true,
        });
        this._edges.styles.create('Blue lines', allMeshes, this._currentWorld, redLine, salmonFill, redOutline);
    };
    //Info/controls
    IFCViewer.prototype.setupStatsPanel = function () {
        var _a, _b, _c;
        if (!!process.env.REACT_APP_MODE && process.env.REACT_APP_MODE === 'development') {
            this._statsPanel = new Stats();
            this._statsPanel.showPanel(2);
            (_a = this._sceneContainerRef) === null || _a === void 0 ? void 0 : _a.current.append(this._statsPanel.dom);
            this._onBeforeUpdateHandlerRef = this.onBeforeUpdateHandler.bind(this);
            this._onAfterUpdateHandlerRef = this.onAfterUpdateHandler.bind(this);
            (_b = this._currentWorld) === null || _b === void 0 ? void 0 : _b.renderer.onBeforeUpdate.add(this._onBeforeUpdateHandlerRef);
            (_c = this._currentWorld) === null || _c === void 0 ? void 0 : _c.renderer.onAfterUpdate.add(this._onAfterUpdateHandlerRef);
            this._statsPanel.dom.style.cssText =
                'position: absolute; top: 10px; left: 10px; z-index: unset;';
        }
    };
    IFCViewer.prototype.setupControlPanel = function (uiControlPanelConstructor) {
        var _a;
        this._loadIfcFileHandlerRef = this.loadIfcFileHandler.bind(this);
        this._disposeFragmentsHandlerRef = this.disposeFragmentsHandler.bind(this);
        var uiPanel = uiControlPanelConstructor({
            world: this._currentWorld,
            clipper: this._currentClipper,
            grid: this._currentGrid,
            edges: this._edges,
        }, {
            loadIfcFileHandler: this._loadIfcFileHandlerRef,
            disposeFragmentsHandler: this._disposeFragmentsHandlerRef,
        });
        (_a = this._controlPanelContainerRef) === null || _a === void 0 ? void 0 : _a.current.append(uiPanel);
    };
    IFCViewer.prototype.setupIFCModelInfoPanel = function (modelInfoPanelConstructor) {
        var _a;
        var panel = modelInfoPanelConstructor({
            components: this._components,
            relationsTree: this._currentRelationsTree,
        });
        (_a = this._modalInfroPanelContainerRef) === null || _a === void 0 ? void 0 : _a.current.append(panel);
    };
    IFCViewer.prototype.setupUI = function (uiOptions) {
        Manager.init();
        this.setupControlPanel(uiOptions.uiControlPanelConstructor);
        this.setupIFCModelInfoPanel(uiOptions.modelInfoPanelConstructor);
    };
    //Scene handlers
    IFCViewer.prototype.onKeyDownHandler = function (event) {
        if (event.code === 'Delete' || event.code === 'Backspace') {
            if (this._currentClipper && this._currentClipper.enabled) {
                this._currentClipper.delete(this._currentWorld);
            }
        }
    };
    IFCViewer.prototype.onDoubleClickHandler = function () {
        if (this._currentClipper && this._currentClipper.enabled) {
            this._currentClipper.create(this._currentWorld);
        }
    };
    IFCViewer.prototype.onResizeHandler = function () {
        var _a, _b;
        (_a = this._currentWorld) === null || _a === void 0 ? void 0 : _a.renderer.resize();
        (_b = this._currentWorld) === null || _b === void 0 ? void 0 : _b.camera.updateAspect();
    };
    IFCViewer.prototype.onBeforeUpdateHandler = function () {
        this._statsPanel.begin();
    };
    IFCViewer.prototype.onAfterUpdateHandler = function () {
        this._statsPanel.end();
    };
    IFCViewer.prototype.projectionOnChanged = function () {
        if (this._currentGrid) {
            var projection = this._currentWorld.camera.projection.current;
            this._currentGrid.fade = projection === 'Perspective';
        }
    };
    IFCViewer.prototype.cameraControlendHandler = function () {
        this._currentCuller.needsUpdate = true;
    };
    IFCViewer.prototype.loadIfcFileHandler = function () {
        return __awaiter(this, void 0, void 0, function () {
            var input, handleFileLoad;
            var _this = this;
            return __generator(this, function (_a) {
                input = document.createElement('input');
                input.type = 'file';
                input.accept = '.ifc';
                input.style.display = 'none';
                handleFileLoad = function (event) { return __awaiter(_this, void 0, void 0, function () {
                    var file, reader;
                    var _this = this;
                    var _a;
                    return __generator(this, function (_b) {
                        file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
                        if (!file)
                            return [2 /*return*/];
                        reader = new FileReader();
                        reader.readAsArrayBuffer(file);
                        reader.onload = function () { return __awaiter(_this, void 0, void 0, function () {
                            var buffer, model;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        buffer = new Uint8Array(reader.result);
                                        return [4 /*yield*/, this._currentFragmentIfcLoader.load(buffer)];
                                    case 1:
                                        model = _a.sent();
                                        model.name = file.name;
                                        this.setupClipperStyles(model);
                                        this._currentWorld.scene.three.add(model);
                                        this.setupCuller();
                                        document.body.removeChild(input);
                                        input.removeEventListener('change', handleFileLoad);
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        return [2 /*return*/];
                    });
                }); };
                input.addEventListener('change', handleFileLoad);
                document.body.appendChild(input);
                input.click();
                return [2 /*return*/];
            });
        });
    };
    IFCViewer.prototype.disposeFragmentsHandler = function () {
        this._currentFragmentsManager.dispose();
    };
    IFCViewer.prototype.onFragmentsLoadedHandler = function (model) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._currentWorld.scene)
                            this._currentWorld.scene.three.add(model);
                        if (!model.hasProperties) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._currentIfcRelationsIndexer.process(model)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return IFCViewer;
}());
export { IFCViewer };
